// utils
import handleError from 'utils/handle-error';
import clearReduxStore from 'utils/clear-redux-store';
import callAzureFunctionAuth from 'utils-ts/call-azure-function-auth';

const USER_TYPE_LOGOUT_PATH_MAP = {
  admin: '/login',
  manager: '/login-manager',
  'ext-user': '/login-ext-user'
};

// a list of route paths that should be ignored when redirecting after logout
const LOGOUT_REDIRECT_EXCLUSIONS = [
  // auth
  '/login',
  '/login-manager',
  '/login-ext-user',
  '/redirect',
  '/forgot-password',
  '/reset-password',
  // public booking
  '/booking-page',
  // public survey
  '/surveys',
  // api routes
  '/api'
];

const getUserTypeLogoutPath = (userType) => USER_TYPE_LOGOUT_PATH_MAP[userType] || '/login';

const handleLogout = async () => {
  try {
    // invalidate cookies
    await callAzureFunctionAuth({
      url: `/auth-remove-access`,
      method: 'get'
    });
  } catch (error) {
    handleError(error);
  } finally {
    // clear redux store values
    clearReduxStore();

    // initiate logout action to all other tabs
    localStorage.setItem('isLoggedIn', false);
  }
};

const shouldSkipLogoutRedirectForPath = (pathname) => LOGOUT_REDIRECT_EXCLUSIONS.some((ex) => pathname.startsWith(ex));

const setLastRecordedActivity = () => {
  // record timestamp of last activity
  localStorage.setItem('lastRecordedActivity', new Date().toISOString());
};

export { handleLogout, setLastRecordedActivity, getUserTypeLogoutPath, shouldSkipLogoutRedirectForPath };
